import platforms from '../../constants/platforms';

const { TWITCH, YOUTUBE } = platforms;

export const usesChannel = platform => [TWITCH].includes(platform);
export const hasSeparateChat = platform => [TWITCH, YOUTUBE].includes(platform);
